import { Sort } from '@types'

export const formatSortParams = (params?: Sort[]) => {
  const result = params
    ?.filter(item => !!item.field)
    .map(({ field, sortDirection }, index) => ({
      field,
      sortDirection,
      index,
    }))
  if (!result?.length) return
  return result
}
